import { jsx as _jsx } from "react/jsx-runtime";
import { useFarbwelt, useTestId } from "@/hooks";
import { Box } from "@gemini/core";
export const FarbweltCardBanner = ({ BoxProps, height = "sizing.48", }) => {
    const { bgColor, isFarbweltActive, logo, } = useFarbwelt();
    const testId = useTestId("Farbwelt.CardBanner");
    const hasBanner = bgColor || logo;
    if (!hasBanner)
        return null;
    return (_jsx(Box, { position: "absolute", top: "0", left: "0", right: "0", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16", height: height, unsafe_style: {
            backgroundColor: isFarbweltActive ? bgColor : "transparent",
        }, testId: testId, ...BoxProps }));
};
